<!-- Cycle Time Raporu Popup -->
<div [id]="popoverId" popover class="cycle-time-popup">
    <!-- Başlık -->
    <div class="popup-header">
        <span class="header-title">
            <i class="clock icon"></i> Cycle Time Analizi
        </span>
        <button [attr.popovertarget]="popoverId" popovertargetaction="hide" class="close-btn">✕</button>
    </div>

    <!-- İçerik -->
    <div class="popup-content" *ngIf="rapor">
        <!-- Özet Kartları -->
        <div class="summary-cards">
            <div class="card card-total">
                <div class="card-label">TOPLAM SÜRE</div>
                <div class="card-value total">{{rapor.toplamSureStr}}</div>
            </div>
            <div class="card card-machining">
                <div class="card-label">İŞLEME SÜRESİ</div>
                <div class="card-value machining">{{rapor.islemeSureStr}}</div>
            </div>
        </div>

        <!-- Süre Dağılımı Bar -->
        <div class="distribution-section">
            <div class="section-label">Süre Dağılımı</div>
            <div class="distribution-bar">
                <div class="bar-segment machining"
                     [style.width.%]="rapor.islemeYuzde"
                     title="İşleme">
                    {{rapor.islemeYuzde > 8 ? rapor.islemeYuzde.toFixed(0)+'%' : ''}}
                </div>
                <div class="bar-segment approach"
                     [style.width.%]="rapor.yaklasmYuzde"
                     title="Yaklaşma">
                    {{rapor.yaklasmYuzde > 8 ? rapor.yaklasmYuzde.toFixed(0)+'%' : ''}}
                </div>
                <div class="bar-segment retract"
                     [style.width.%]="rapor.uzaklasmaYuzde"
                     title="Uzaklaşma">
                    {{rapor.uzaklasmaYuzde > 8 ? rapor.uzaklasmaYuzde.toFixed(0)+'%' : ''}}
                </div>
                <div class="bar-segment rapid"
                     [style.width.%]="rapor.bostaYuzde"
                     title="Boşta/Rapid">
                    {{rapor.bostaYuzde > 8 ? rapor.bostaYuzde.toFixed(0)+'%' : ''}}
                </div>
            </div>
            <div class="bar-legend">
                <span><span class="dot machining"></span> İşleme</span>
                <span><span class="dot approach"></span> Yaklaşma</span>
                <span><span class="dot retract"></span> Uzaklaşma</span>
                <span><span class="dot rapid"></span> Boşta</span>
            </div>
        </div>

        <!-- Detay Tablosu -->
        <div class="detail-section">
            <div class="section-label">Detaylı Analiz</div>
            <table class="detail-table">
                <tr>
                    <td class="label machining">İşleme Süresi</td>
                    <td class="value">{{rapor.islemeSureStr}}</td>
                    <td class="percent">{{rapor.islemeYuzde.toFixed(1)}}%</td>
                </tr>
                <tr>
                    <td class="label approach">Yaklaşma Süresi</td>
                    <td class="value">{{rapor.yaklasmaStr}}</td>
                    <td class="percent">{{rapor.yaklasmYuzde.toFixed(1)}}%</td>
                </tr>
                <tr>
                    <td class="label retract">Uzaklaşma Süresi</td>
                    <td class="value">{{rapor.uzaklasmaStr}}</td>
                    <td class="percent">{{rapor.uzaklasmaYuzde.toFixed(1)}}%</td>
                </tr>
                <tr>
                    <td class="label rapid">Boşta (Rapid)</td>
                    <td class="value">{{rapor.bostaStr}}</td>
                    <td class="percent">{{rapor.bostaYuzde.toFixed(1)}}%</td>
                </tr>
                <tr class="total-row">
                    <td class="label">TOPLAM</td>
                    <td class="value total">{{rapor.toplamSureStr}}</td>
                    <td class="percent">100%</td>
                </tr>
            </table>
        </div>

        <!-- Hareket İstatistikleri -->
        <div class="stats-section">
            <div class="section-label">Hareket İstatistikleri</div>
            <div class="stats-grid">
                <div class="stat-item">
                    <span class="stat-label">Toplam Hareket:</span>
                    <span class="stat-value">{{rapor.toplamHareket}}</span>
                </div>
                <div class="stat-item">
                    <span class="stat-label">İşleme Hareketi:</span>
                    <span class="stat-value machining">{{rapor.islemeHareket}}</span>
                </div>
                <div class="stat-item">
                    <span class="stat-label">Toplam Mesafe:</span>
                    <span class="stat-value">{{rapor.toplamMesafe.toFixed(1)}} mm</span>
                </div>
                <div class="stat-item">
                    <span class="stat-label">İşleme Mesafesi:</span>
                    <span class="stat-value machining">{{rapor.islemeMesafe.toFixed(1)}} mm</span>
                </div>
            </div>
        </div>

        <!-- Verimlilik Skoru -->
        <div class="efficiency-section">
            <div class="efficiency-header">
                <div>
                    <div class="efficiency-label">VERİMLİLİK SKORU</div>
                    <div class="efficiency-sublabel">İşleme / Toplam Süre</div>
                </div>
                <div class="efficiency-value" [style.color]="getVerimlilikRenk()">
                    {{rapor.verimlilik.toFixed(0)}}%
                </div>
            </div>
            <div class="efficiency-bar">
                <div class="efficiency-fill"
                     [style.width.%]="rapor.verimlilik"
                     [style.background]="getVerimlilikGradient()">
                </div>
            </div>
        </div>

        <!-- İyileştirme Önerileri -->
        <div *ngIf="rapor.oneriler?.length > 0" class="suggestions-section">
            <div class="section-label suggestions">
                <i class="lightbulb icon"></i> İyileştirme Önerileri
            </div>
            <div *ngFor="let oneri of rapor.oneriler" class="suggestion-item">
                {{oneri}}
            </div>
        </div>
    </div>

    <!-- Alt Bar -->
    <div class="popup-footer">
        <span class="footer-info">Reel İlerleme: %{{reelIlerleme}} ile hesaplandı</span>
        <button class="copy-btn" (click)="raporuKopyala()">
            <i class="copy icon"></i> Kopyala
        </button>
    </div>
</div>
